import { BreadcrumbGroupProps } from "@amzn/awsui-components-react/polaris/breadcrumb-group";
import { useNavigate } from "react-router-dom";
import { breadcrumbsUpdated } from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";

/**
 * Hook for handling breadcrumb redux state
 */
export const useBreadcrumbs = () => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.breadcrumbs);

  return {
    getBreadcrumbs: () => selector,
    updateBreadcrumbs: (payload: BreadcrumbGroupProps.Item[]) =>
      dispatch(breadcrumbsUpdated(payload)),
  };
};

/**
 * Hook for handling breadcrumb group events
 */
export const useOnClickHandler = () => {
  const navigate = useNavigate();

  return (event: CustomEvent<BreadcrumbGroupProps.ClickDetail>) => {
    if (!event.detail.external) {
      event.preventDefault();
      // Empty-string href opts a crumb out of navigation (still rendered as
      // a link by BreadcrumbGroup, but clicks are inert). Callers use this to
      // model non-clickable middle crumbs. Existing callers pass "/" or "#"
      // so this branch never fires for them.
      if (!event.detail.href) return;
      navigate(event.detail.href, { replace: true });
    }
  };
};
